import router from './../router'
import Auth from '@/providers/Auth'
const AuthProvider = new Auth()


export const LOGOUT = ({commit, state}) => {
    return AuthProvider.logout().then((response) => {
      //Cookies.remove(process.env.U4CROWD_COOKIE, { path: '/', domain: process.env.COKIEE_DOMAIN })
      commit('SET_CURRENT_USER', { user: null })
      commit('SET_TOKEN', { token: null })
      commit('SET_SIGNATURE', { signature: null })
      router.push('/')
      location.reload()
    }).catch((e) => {
    })
}

export const SET_AUTH_TOKEN = ({commit, state}, jwt) => {
  return new Promise((resolve, reject) => {
    commit('SET_TOKEN', {token: jwt})
    AuthProvider.getCurrentUser().then((user) => {
      commit('SET_CURRENT_USER', {
        user: {
          role: user.data.data.attributes.role,
          id: user.data.data.id,
          email: user.data.data.attributes.email,
          name: user.data.data.attributes.name,
          address: user.data.data.attributes.address,
          phone: user.data.data.attributes.phone,
          rfc: user.data.data.attributes.rfc,
          timezone: user.data.data.attributes.timezone,
          locale: user.data.data.attributes.locale,
          is_admin: user.data.data.attributes.is_admin,
          permissions: user.data.data.attributes.permissions,
          img_profile: user.data.data.attributes.img_profile,
        }
      })
      
      router.push('/panel')
      
      location.reload()

      resolve(true)
    })
    .catch((err) => {
      reject(err)
    })
  })
}

export const SET_SIGNATURE = ({commit, state}, signature) => {
  return new Promise((resolve, reject) => {
    commit('SET_SIGNATURE', { signature: signature })
    resolve(true)
  })
}